import React, { JSX } from "react";
import { isTableLine } from "./chatbot.utils";

export const renderInline = (text: string, keyPrefix: string): React.ReactNode[] => {
  const tokens = text.split(/(\*\*.*?\*\*|\*.*?\*)/g);
  return tokens.map((token, i) => {
    if (token.startsWith("**") && token.endsWith("**"))
      return <strong key={`${keyPrefix}-${i}`}>{token.slice(2, -2)}</strong>;
    if (token.startsWith("*") && token.endsWith("*"))
      return <em key={`${keyPrefix}-${i}`}>{token.slice(1, -1)}</em>;
    return token;
  });
};

const parseMarkdownTable = (lines: string[], mdTableClass: string): JSX.Element => {
  const isMarkdown = lines[0].trim().startsWith("|");
  const rows = isMarkdown
    ? lines
        .filter((l) => !l.match(/^\|[-| ]+\|$/))
        .map((l) =>
          l.split("|").filter((_, i, arr) => i > 0 && i < arr.length - 1).map((c) => c.trim())
        )
    : lines.map((l) => l.split("\t").map((c) => c.trim()));

  return (
    <table className={mdTableClass}>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>
            {row.map((cell, j) => (
              <td key={j}>{renderInline(cell, `cell-${i}-${j}`)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export const renderMessage = (text: string, mdTableClass: string): React.ReactNode[] => {
  const lines = text.split("\n");
  const result: React.ReactNode[] = [];
  let tableBuffer: string[] = [];

  const flushTable = () => {
    if (tableBuffer.length) {
      result.push(parseMarkdownTable(tableBuffer, mdTableClass));
      tableBuffer = [];
    }
  };

  lines.forEach((line, i) => {
    if (isTableLine(line)) {
      tableBuffer.push(line);
    } else {
      flushTable();
      result.push(...renderInline(line, `line-${i}`));
      if (i < lines.length - 1) result.push(<br key={`br-${i}`} />);
    }
  });
  flushTable();
  return result;
};
